import React from "react";
import LegalPage from "@/pages/LegalPage";

const Privacy = () => (
  <LegalPage
    title="Privacy Policy"
    lastUpdated="December 2025"
    sections={[
      {
        heading: "Who we are",
        body: [
          "MatiMitra Carbon Solutions Pvt. Ltd. (\"MatiMitra\", \"we\", \"us\") is a durable biochar carbon-removal project incorporated in Odisha, India (CIN U20119OD2025PTC050168). This Privacy Policy describes how we collect, use and safeguard information you share with us through this website.",
        ],
      },
      {
        heading: "Information we collect",
        body: [
          "When you submit our contact form we collect your full name, email address, organisation (optional), the inquiry type you select, and the message you write. We do not use third-party analytics or advertising trackers on this site.",
          "When you visit the site, your browser may share standard request data (such as IP address, user-agent and referrer) with our hosting infrastructure for the purpose of serving pages and protecting against abuse.",
        ],
      },
      {
        heading: "How we use it",
        body: [
          "We use contact submissions solely to respond to your enquiry, to share project information you request, and to keep a record of our correspondence with you. We will not sell, rent or share your personal information with third parties for marketing purposes.",
        ],
      },
      {
        heading: "Where it lives",
        body: [
          "Submissions are stored in our project database, hosted on secure cloud infrastructure. Access is limited to authorised members of the MatiMitra team.",
        ],
      },
      {
        heading: "Your rights",
        body: [
          "You may ask us to access, correct or delete the personal information you have shared with us at any time. Write to support@matimitra.earth and we will respond within a reasonable period.",
        ],
      },
      {
        heading: "Contact",
        body: [
          "For any privacy-related questions, please email support@matimitra.earth.",
        ],
      },
    ]}
  />
);

export default Privacy;
